interface TagKeyValue {
  key: string;
  value?: string | null;
}

/** What a tag filter selects: keys alone, or whole key=value pairs. */
export type TagFilterMode = 'key' | 'key-value';

/** Names what a selection holds, for counts — "3 pairs selected" needs no reminder of what a pair is. */
export const tagEntityLabel = (mode: TagFilterMode) =>
  mode === 'key-value' ? 'key-value pair' : mode;

/** Names what the user is asked to pick, where guidance copy has room to say which kind of pair. */
export const tagOptionLabel = (mode: TagFilterMode) =>
  mode === 'key-value' ? 'key-value pair' : mode;

export const toTagKeyValues = (
  values: string[]
): { key: string; value?: string }[] =>
  values.map((item) => {
    const separatorIndex = item.indexOf('=');
    if (separatorIndex === -1) {
      return { key: item };
    }
    return {
      key: item.slice(0, separatorIndex),
      value: item.slice(separatorIndex + 1),
    };
  });

export const fromTagKeyValues = (values: TagKeyValue[]): string[] =>
  values.map((item) =>
    item.value === undefined || item.value === null
      ? item.key
      : `${item.key}=${item.value}`
  );
